module.exports = __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmWUlfCRc4AMP6lbBP.baa7761b.woff2";